import createIcon from '../../createIcon';

/**
 * @component @name NotificationImportant
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggMTUuNzVWMTAuNzVDMTggNy42OCAxNi4zNiA1LjExIDEzLjUgNC40M1YzLjc1QzEzLjUgMi45MiAxMi44MyAyLjI1IDEyIDIuMjVDMTEuMTcgMi4yNSAxMC41IDIuOTIgMTAuNSAzLjc1VjQuNDNDNy42MyA1LjExIDYgNy42NyA2IDEwLjc1VjE1Ljc1TDQgMTcuNzVWMTguNzVIMjBWMTcuNzVMMTggMTUuNzVaTTEzIDE1Ljc1SDExVjEzLjc1SDEzVjE1Ljc1Wk0xMyAxMS43NUgxMVY3Ljc1SDEzVjExLjc1Wk0xMiAyMS43NUMxMy4xIDIxLjc1IDE0IDIwLjg1IDE0IDE5Ljc1SDEwQzEwIDIwLjg1IDEwLjg5IDIxLjc1IDEyIDIxLjc1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NotificationImportant = createIcon('NotificationImportant', [
  [
    'path',
    {
      d: 'M18 15.75V10.75C18 7.68 16.36 5.11 13.5 4.43V3.75C13.5 2.92 12.83 2.25 12 2.25C11.17 2.25 10.5 2.92 10.5 3.75V4.43C7.63 5.11 6 7.67 6 10.75V15.75L4 17.75V18.75H20V17.75L18 15.75ZM13 15.75H11V13.75H13V15.75ZM13 11.75H11V7.75H13V11.75ZM12 21.75C13.1 21.75 14 20.85 14 19.75H10C10 20.85 10.89 21.75 12 21.75Z',
      key: 'xvx3lp',
    },
  ],
]);

export default NotificationImportant;
